// extracted by mini-css-extract-plugin
export default {"h2Cont":"TitleH2_h2Cont__x5WTi","topLine":"TitleH2_topLine__-5Zj-"};